<div [ngClass]='containerClass' class='layout-wrapper' [class.has-update-banner]='versionCheck.updateAvailable()'>
  <app-background-video />
  <app-update-banner />

<div class='header-row px-4 pt-4'>

  <div class='header-left'>
    @if (!hideLayout()) {
      <app-navbar />
    } @else {
        <a routerLink='/auth/login' (click)='onLogoClick($event)'>
            <img
                    src="assets/layout/images/{{ layoutService.config().colorScheme === 'light' ? 'logo-black' : 'logo-white' }}.svg"
                    alt='logo'
                    class='logo-img'
            />
        </a>
    }
  </div>

  <div class='header-right' *ngIf='showLogout()'>
    <p-button
  [label]="'COMPANIES.DISABLED.ACTIONS.LOGOUT' | translate"
  severity='contrast'
  [outlined]='true'
  icon='pi pi-sign-out'
  (onClick)='logout()'
  styleClass='border-white text-white hover:bg-white hover:text-gray-800 text-sm md:text-base logout-btn'
/>

  </div>

</div>


  <p-toast />
  <router-outlet />

  @if (!hideLayout()) {
    <app-footer />
  }

  <div class='layout-mask'></div>

  <app-welcome-dialog
    [(visible)]='layoutService.showWelcomeDialog'
    [donShowAgainValue]='layoutService.getWelcomeDialogDontShowAgain'
    (dontShowAgain)='layoutService.onWelcomeDialogDontShowAgain()'
  >
  </app-welcome-dialog>

  <app-contact-dialog [(visible)]='layoutService.showContactDialog'>
  </app-contact-dialog>

  <app-access-denied-dialog [(visible)]='layoutService.showAccessDeniedDialog'>
  </app-access-denied-dialog>

  <app-mobile-warning-dialog 
    [(visible)]='layoutService.showMobileWarningDialog'
    (closed)='onMobileWarningClosed()'>
  </app-mobile-warning-dialog>

  <app-tutorial-dialog
    [(visible)]='layoutService.showTutorialDialog'
    [(dontShowAgainValue)]='layoutService.tutorialDontShowAgainValue'
    (dontShowAgain)='layoutService.onTutorialDontShowAgain()'
    (startTour)='layoutService.onTutorialStartRequested()'>
  </app-tutorial-dialog>

  <app-offers-tutorial-dialog
    [(visible)]='layoutService.showOffersTutorialDialog'
    [(dontShowAgainValue)]='layoutService.offersTutorialDontShowAgainValue'
    [introEnabled]='layoutService.chainedTourActive()'
    (dontShowAgain)='layoutService.onOffersTutorialDontShowAgain()'
    (startTour)='layoutService.onOffersTutorialStartRequested()'
    (closed)='onOffersTutorialClosed()'>
  </app-offers-tutorial-dialog>

  <app-tour-finished-dialog
    [(visible)]='layoutService.showTourFinishedDialog'
    [showCandidatesHint]='layoutService.tourFinishedShowCandidatesHint()'
    (closed)='onTourFinishedClosed()'>
  </app-tour-finished-dialog>

  <app-confirmation-modal />
</div>
